import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { withStyles } from '@material-ui/core'

import SimpleModal from '../common/SimpleModal'

import * as CONSTANTS from '../../utils/constants'
import * as STOCKS from '../../redux/actions/stocks'

import InputGenerator from '../common/subComponents/InputGenerator'

const styles = theme => ({
    modalContainer: {
        paddingTop: 18,
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
        color: 'black'
    },
    rentModalContainer: {
        display: 'flex',
        flexDirection: 'row'
    },
    clientContainer: {
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        borderRight: '1px solid rgba(0,0,0,0.1)'
    },
    detailsContainer: {
        flex: 1,
        padding: 20
    },
    equalFlex: {
        flex: 1
    },
    inputPadding: {
        paddingRight: 10,
        paddingTop: 2
    },
})

class SalePVPPModal extends Component {

    initialFields = [
        { value: '', type: 'date', label: this.props.language.itemDetails.offer.rent.processDate, name: 'PVPPContractDate' }
    ]

    state = {
        openModal: false,
        renderPage: false,
        modalFields: this.initialFields,
    }

    InputWrapper = ({ input, keyProps, shrink, onChange }) => <div className={`${this.props.classes.equalFlex} ${this.props.classes.inputPadding}`}>
        <InputGenerator
            key={keyProps}
            fullWidth={true}
            InputLabelProps={shrink ? { shrink: true } : {}}
            margin="dense"
            {...input}
            onChange={event => onChange(event)}
        />
    </div>

    componentDidUpdate(prevProps) {
        if (this.props.open && !prevProps.open) {
            this.openHandler()
        }
        if (prevProps.open && !this.props.open) {
            this.setState({
                openModal: false
            })
        }
    }


    onCloseHandler = () => {
        this.props.onClose()
        this.setState({ modalFields: this.initialFields, openModal: false })
    }

    openHandler = () => {
        let fieldsCopy = [...this.state.modalFields].map(field => ({ ...field }))
        const fromDateIndex = fieldsCopy.findIndex(index => index.name === 'PVPPContractDate')
        if (fromDateIndex > -1) {
            fieldsCopy[fromDateIndex].value = this.props.row.PVPPContractDate ? moment(this.props.row.PVPPContractDate).format(CONSTANTS.INPUT_TYPE_DATE_FORMAT) : null

            this.setState({
                openModal: true,
                renderPage: true,
                modalFields: fieldsCopy
            })
        }
    }


    renderFields = () => {

        const InputWrapper = this.InputWrapper

        let jsonMap = {}
        this.state.modalFields.forEach(field => {
            jsonMap[field.name] = field
        })

        return (
            <>
                <InputWrapper input={jsonMap['PVPPContractDate']} key={'PVPPContractDate'} onChange={event => this.onChangeHandler(event)} shrink={true} />
            </>
        )

    }

    onChangeHandler = event => {
        const fieldsCopy = [...this.state.modalFields].map(field => ({ ...field }))
        const currentIndex = fieldsCopy.findIndex(index => index.name === event.target.name)

        if (currentIndex > -1) {
            fieldsCopy[currentIndex].value = event.target.value
            this.setState({ modalFields: fieldsCopy })
        }
    }

    onCreate = () => {

        let jsonMap = {}
        this.state.modalFields.forEach(field => {
            jsonMap[field.name] = field
        })
        this.props.onClose()
        window.open(`${CONSTANTS.BACKEND_URL}inWorks/${this.props.row.id}/pvpp?contractDate=${jsonMap['PVPPContractDate'].value}`, "_blank")
    }

    render() {
        const { language } = this.props

        return this.state.renderPage ? <SimpleModal
            styles={this.props.classes}
            open={this.state.openModal}
            onClose={() => this.onCloseHandler()}
            onCancel={() => this.onCloseHandler()}
            onAccept={() => this.onCreate()}
            withCancelButton={true}
            acceptButtonText={language.offer.createModal.generate}
            cancelButtonText={language.offer.createModal.cancel}
            canSubmitForm={true}
            title={language.offer.createModal.pvppRentTitle}
            maxWidth={'sm'}
        >
            {this.renderFields()}
        </SimpleModal> : null
    }
}
const mapStateToProps = reducers => ({
    language: reducers.languageReducer.i18n
})

const mapDispatchToProps = dispatch => ({
})

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(SalePVPPModal))